import React, { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function MyEditor(props) {
  const backgroundColor = props.disabled ? "#ddd" : "white"; // Set background color

  // Use a ref to access the quill instance directly
  const quillRef = useRef();

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  return (
    <ReactQuill
      ref={quillRef}
      placeholder={"write description"}
      theme="snow"
      readOnly={props.disabled}
      value={props.value}
      onChange={props.setValue}
      modules={modules}
      formats={formats}
      style={{
        height: "200px",
        backgroundColor: backgroundColor,
        cursor: props.disabled ? "not-allowed" : "auto",
      }}
    />
  );
}
export default MyEditor;
